import { Injectable } from '@angular/core';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Service class to holds breadcrumb data (obsolete)
 **/
@Injectable()
export class BreadcrumbService {

  constructor() { }

  isValid: boolean;
    getBreadcrumb(){
        return breadcrumb;
    }

    getValid(){
        return isValid;
    }
}

const isValid = {
    value: false
};
const breadcrumb = {
    id: 1,
    name: '',
    url: ''
};



// WEBPACK FOOTER //
// ./src/app/header/breadcrumb/breadcrumb.service.ts